import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "../table/workspace/WorkspaceContainer";
import Routes from "../../../navigation/route/Route";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ActionsColumn from "../table/ActionsColumn";
import {CellInfo} from "react-table";
import {WildcardFilterColumnType} from "../../../model/workspace/WildcardFilter";

type Props = RouteComponentProps<any>;

class LeadWorkspaceContainer extends React.Component<Props, {}> {
	render() {
		return (
			<WorkspaceContainer workspaceName={WorkspaceName.Leads}
								onRowClick={(rowId: string) => this.props.history.push(Routes.EditLead(rowId))}
								rowToId={(row) => row.referenceNumber}
								renderButton={this.renderCreateLeadButton}
								wildcardFilterColumnType={WildcardFilterColumnType.LeadJobs}
								lastColumn={(row: CellInfo) => <ActionsColumn
									route={Routes.EditLead(row.original.referenceNumber)}/>}/>
		)
	}

	renderCreateLeadButton = () =>
		<ButtonPrimary label={"Create lead"}
					   onClick={() => this.props.history.push(Routes.CreateLead)}/>;

}

export default withRouter(LeadWorkspaceContainer);
